module.exports = __webpack_public_path__ + "img/icon__eye.2d243a93.svg";